import React from 'react'
import { IonIcon, IonButton } from '@ionic/react'
import { useTranslation } from 'react-i18next'
import { barcode } from 'ionicons/icons'
import { AppRouterConstants } from '../../../components/appRouter/AppRouter.constants'
import { useHistory } from 'react-router-dom'

export interface ScanDriversLicenseButtonProps {
  color?: string
}

const ScanDriversLicenseButton = (props: ScanDriversLicenseButtonProps) => {
  const { color } = props

  const history = useHistory()
  const { t } = useTranslation()

  const onScanDriversLicenseClick = () => {
    history.push(AppRouterConstants.DL_SCANNER_ROUTE)
  }

  return (
    <IonButton
      data-testid='ScanDriversLicense'
      className='scan-drivers-license-button'
      expand='block'
      fill='clear'
      color={color}
      onClick={onScanDriversLicenseClick}>
      <IonIcon icon={barcode} size='large' />
      {t('dl.ScanDriversLicense')}
    </IonButton>
  )
}

export default ScanDriversLicenseButton
